import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isLocalDataBackedMailboxInfo } from 'owa-account-source-list/lib/utils/isLocalDataBackedAccount';
import { getAccountScopeUserSettings } from 'owa-session-store';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const recoverableDeleteCapability: Capability = {
    isEnabled: (mailboxInfo?: MailboxInfo) => {
        if (!mailboxInfo) {
            return false;
        }
        return getAccountScopeUserSettings(mailboxInfo).RecoverDeletedItemsEnabled ?? false;
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        if (!mailboxInfo) {
            return false;
        }
        return !isLocalDataBackedMailboxInfo(mailboxInfo);
    },
};
